import React from 'react';
import LinkModel from '../../Types/LinkModel';
import clsx from 'clsx';

export interface BannerSliderItemProps {
  title?: string;
  bodyText?: string;
  link?: LinkModel;
  imageUrl: string;
  imageAlt?: string;
  mobileImageUrl?: string;
  mobileImageAlt?: string;
  overlay?: boolean;
  textPlacement?: string;
}

const bannerSliderItemImageClasses =
  'col-start-1 row-start-1 w-full object-cover aspect-[unset]';

const BannerSliderItem = (props: BannerSliderItemProps) => {
  const {
    title,
    bodyText,
    link,
    imageUrl,
    mobileImageUrl,
    overlay,
    textPlacement,
    imageAlt,
    mobileImageAlt,
  } = props;
  const hasLinkButton = link?.text;

  return (
    <a
      className="grid grid-cols-1 text-white overflow-hidden duration-300 text-center"
      href={link?.href}
    >
      {!!mobileImageUrl ? (
        <>
          <img
            className={`${bannerSliderItemImageClasses} block md:hidden`}

            src={mobileImageUrl}
            alt={mobileImageAlt ?? imageAlt}
          />
          <img
            className={`${bannerSliderItemImageClasses} hidden md:block`}
            src={imageUrl}
            alt={imageAlt}
          />
        </>
      ) : (
        <img
          className={bannerSliderItemImageClasses}
          src={imageUrl}
          alt={imageAlt}
        />
      )}
      <div
        className={clsx(
          `text-white md:p-10 lg:p-12 w-full h-full col-start-1 row-start-1 z-20 flex flex-col items-center justify-center max-w-[auto] mx-auto p-6 box-border`,
          textPlacement == 'left' && 'items-start justify-end'
        )}
      >
        <h4 className="text-white font-satoshi-black text-[32px] leading-[39px] uppercase mb-2 md:text-[36px] md:leading-[44px] lg:text-[57px] lg:leading-[69px]">
          {title}
        </h4>
        {bodyText && <p className="text-lg text-white">{bodyText}</p>}
        {hasLinkButton && (
          <a
            href={link.href}
            className="mt-4 btn btn--large btn--primary self-center"
          >
            {link.text}
          </a>
        )}
      </div>
      {overlay && (
        <div className="col-start-1 row-start-1 w-full h-full z-10 bg-[rgba(0,0,0,0.551)] pointer-events-none"></div>
      )}
    </a>
  );
};

export default BannerSliderItem;
